module.exports = function index(size) {
  if (typeof size !== "number") throw new TypeError("".concat(size, " is not a number!"));
  var sizes = [" Bytes", " KB", " MB", " GB", " TB", " PB", " EB", " ZB", " YB"];

  for (var i = 1; i < sizes.length; i++) {
    if (size < Math.pow(1024, i)) return Math.round(size / Math.pow(1024, i - 1) * 100) / 100 + sizes[i - 1];
  }

  return size;
};